import React from 'react';
import { FiPhone, FiCalendar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { SITE_CONFIG } from '../data/content';

const MobileCTA = () => {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 p-4 bg-white/80 backdrop-blur-lg border-t border-gray-100 shadow-[0_-8px_30px_rgb(0,0,0,0.08)] flex gap-3">
      <a 
        href={`tel:${SITE_CONFIG.phone.replace(/\s/g, '')}`}
        className="flex-1 bg-gray-100 text-gray-900 py-4 rounded-2xl font-black flex items-center justify-center gap-2 active:scale-95 transition-transform"
      >
        <SafeIcon icon={FiPhone} /> Call
      </a>
      <a 
        href={SITE_CONFIG.bookingUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-[2] bg-teal-600 text-white py-4 rounded-2xl font-black flex items-center justify-center gap-2 active:scale-95 transition-transform"
      >
        <SafeIcon icon={FiCalendar} /> Book Online
      </a>
    </div>
  );
};

export default MobileCTA;